import React from 'react';
import Button from './Button';
import placeholder from '../../assets/images/placeholder.png';
import { createImageUrl, getEntityName } from '../../helpers/commonHelpers';

const MunicipalityCard = ({ municipality, id, goToMunicipalityDetails, mayor, goToMayorsPage, region }) => {
    return (
        <div className="breed-card">
            <div className="breed-card__triangle breed-card__triangle--top" />
            <div className="breed-card__triangle breed-card__triangle--bottom" />

            <img alt="municipality" src={municipality?.main_image ? createImageUrl(municipality?.main_image) : placeholder} className="breed-card__image" />
            <div className="breed-card__content">
                <h1 className="breed-card__name"> 
                    {municipality?.name}
                </h1>

                <div className="breed-card__stats">

                    <div className="breed-card__stats__left">
                        <h3 className="breed-card__stats__title">
                            Površina: &nbsp;
                            <span className="yellow-dark-text"> 
                                {municipality?.surface} km²
                            </span>
                        </h3>
                        <h3 className="breed-card__stats__title">
                            Broj naselja: &nbsp;
                            <span className="yellow-dark-text"> 
                                {municipality?.settlements} 
                            </span>
                        </h3>
                        <h3 className="breed-card__stats__title">
                            Broj stanovnika: &nbsp;
                            <span className="yellow-dark-text"> 
                                {municipality?.population}
                            </span>
                        </h3>
                        <h3 className="breed-card__stats__title">
                            Entitet: &nbsp;
                            <span className="yellow-dark-text"> 
                                {getEntityName(municipality?.entity) }
                            </span>
                        </h3>
                        <h3 className="breed-card__stats__title">
                            Poštanski broj: &nbsp;
                            <span className="yellow-dark-text"> 
                                {municipality?.zipcode}
                            </span>
                        </h3>
                    </div>

                    <div className="breed-card__stats__right">
                        {municipality?.entity === 'FB' ? 
                            <h3 className="breed-card__stats__title">
                                Kanton:
                            <span className="yellow-dark-text block">
                                    {municipality?.cantonName}
                                </span>
                            </h3> : null}
                        <h3 className="breed-card__stats__title">
                            Web stranica: 
                            <a href={`${municipality?.website}`} rel="noopener noreferrer" target="_blank">
                                <span className="yellow-dark-text block">
                                    {municipality?.name}
                                </span>
                            </a>
                        </h3>
                    </div>

                </div>
                <div className="breed-card__buttons"> 
                    
                    {region ? <Button name={id} onClick={goToMunicipalityDetails} classes="breed-card__button" color="yellow-gradient" text={`Detalji ${region === 'FB' ? 'Općine' : 'Opštine'}`} /> : null}
                    {mayor ? <Button name={mayor} onClick={goToMayorsPage} classes="breed-card__button" color="yellow-gradient" text="Načelnik" />
                : null}
                </div>
            </div>
        </div>
    );
}

export default MunicipalityCard;